module.exports = __webpack_public_path__ + "static/studentsports_elite-11-d368f110081bef8a5afded94b28f908f.jpg";